import { useSelector } from 'react-redux';
import { useEffect, useRef, useState } from 'react';
import './style.css'

interface NotificationProps {
  visibleNotificationBar: any,
  setNotificationBar: any
}
const NotifcationDrawer: React.FC<NotificationProps> = ({ visibleNotificationBar, setNotificationBar }) => {
  let pathname: any = (window.location.pathname).split('/').pop();
  const notificaftionData: any = useSelector((state: any) => {
    return state.notification.data;
  })
  const theme: any = useSelector((state: any) => {
    return state.theme.isTheme;
  })

  const [notificaftions, setNotifications] = useState<any>(localStorage.getItem('notification') ? localStorage.getItem('notification') : [])
  useEffect(() => {
    let notification_: any = localStorage.getItem('notification') ? localStorage.getItem('notification') : [];
    setNotifications(notification_)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [notificaftionData])


  const ref = useRef<any>(null);
  const handleClickOutside = (event: MouseEvent) => {
    const target:any = event?.target as HTMLElement
    if (!target.matches('.common_click')) {      
      setNotificationBar(false)
    }
  };
  document.addEventListener('click', handleClickOutside, true);

  return (
    <div ref={ref}>

      <div className={`notifyArrow ${visibleNotificationBar ? 'open_notifyArrow common_click' : ''}`} style={{ right: `${pathname !== 'live' ? '15px' : ''}` }}></div>
      <div className={`notification_div ${visibleNotificationBar ? 'open_notification_div common_click' : ''}`} >
        <span className='notification_div_inbox common_click'>NOTIFICATIONS </span>
        <div className='notification_All_card common_click'>
          {notificaftions?.length > 0 ?
            ((JSON.parse(notificaftions)).reverse().map((item: any, index: any) => {
              return (
                <>

                  {((item.Target !== "" || item.Stoploss !== "") && item?.s_code) && <div key={index} className='subCardNotif'>

                    <div className='subCardNotif_header common_click'>
                      {item?.Type === "insert" ?
                        <img className='common_click' src='/icons/NewTrade.png' alt="NEW TRADE"/>
                        :item?.Type === "closed" ?  <img className='common_click' src='/icons/Trade_closed.png' alt="Closed Trade"/> : item.Stoploss !== "" && item.Target !== '' && item?.Type === "update" ?
                          <img className='common_click' src='/icons/TS (1).png' alt="TARGET STOPLOSS"/>
                          : item.Target !== "" ? <img className='common_click' src='/icons/Target_icon.png' alt="TARGET" />
                            : <img className='common_click' src='/icons/Stoploss_icon.png' alt="STOPLOSS"/>}

                      <div className='subCardNotif_model_time common_click'>
                        <span className='common_click' style={{ color: `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, fontWeight: "bold" }}>{item?.s_symbol ? item?.s_symbol : item?.symbol} ({item?.s_code}) </span>
                        <span className='common_click' style={{ color: `${theme==='light'?"gray":theme==='b&w'?'#ffffffcf':'#ffffffcf'}`, fontWeight: "400", fontSize: "smaller" }}>{item?.time}</span>
                      </div>
                    </div>

                    {(item.Type === "insert") ? 
                    <span className='common_click' style={{ color: `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, marginLeft: "1rem" }}>
                        New trade opened at {item?.time} 
                      </span> 
                      : (item.Type === "closed") ? 
                        <span className='common_click' style={{ color: `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, marginLeft: "1rem" }}>
                          {item?.value}
                       </span> 
                    :(item.Target !== "" && item.Stoploss !== "") 
                      ? <span className='common_click' style={{ color:  `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, marginLeft: "1rem" }}>
                            Target -{'>'} {Number(item.Target)?.toFixed(2)} and stoploss -{'>'} {Number(item.Stoploss)?.toFixed(2)}
                        </span>
                      : item.Target !== "" ? <span className='common_click' style={{ color: `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, marginLeft: "1rem" }}>Target -{'>'} {Number(item.Target)?.toFixed(2)}</span>
                        : item.Stoploss !== "" ? <span className='common_click' style={{ color: `${theme==='light'?"black":theme==='b&w'?'white':'white'}`, marginLeft: "1rem" }}>Stoploss -{'>'} {Number(item.Stoploss)?.toFixed(2)}</span> : ''}

                  </div>}
                </>
              )
            })) :
            <span className='common_click' style={{color:`${theme==='light'?"black":theme==='b&w'?'white':'white'}`, margin: "auto" }}><i className='common_click'>No New Notifications</i></span>
          }
        </div>
      </div>
    </div>
  );
}



export default NotifcationDrawer;

